import { getWindow } from 'utilities/window.js';

const NotFound = () => (
  <div className="Tile">
    <div className="Tile-body u-textCenter">
      <p>Metservice.com has been updated</p>
      <button
        className="Button u-mB-sm"
        onClick={() => {
          getWindow()?.location?.reload();
        }}
      >
        Click or tap to reload
      </button>
    </div>
  </div>
);

export { NotFound };
